  <template>
  <div class="animated fadeIn">
  <b-breadcrumb><strong>Fit Technician List</strong></b-breadcrumb>
    
  <b-row >
       
    <!----- SideBar All Design List ---->
     <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
      <div class="col-md-12 ">


            <!-- code for table -->
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                  <div class="row mt-4"> 
                  </div> 



              <b-row class="col-md-12 ">
                <input type="hidden" name="isactiveId" id="isactiveId" value="">
                <input type="hidden" name="brand_title" id="brand_title" value="">
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                      <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions">
                          <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                          <option :value="false">Asc</option> <option :value="true">Desc</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>             
                 <!--  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                      <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </b-col>   -->          
              </b-row> 
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
                  <div class="col-md-12">
                    <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields1"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                  


                    <template slot="actions" slot-scope="row">
                      <i @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Vendor Details" class="fa fa-pencil-square-o" aria-hidden="true" style=" color: green;">&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <i class="fa fa-edit"></i> -->
                      </i>
                      <i  v-on:click="deleteinfoModal(row.item)"  data-toggle="tooltip" title="Delete Vendor Details"  class="fa fa-trash" aria-hidden="true" style="color: red">
                         <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                      </i>

                    </template>  

                    <template slot="action" slot-scope="row">

                      <!-- <button type="button" class="btn btn-info" style="width: 110px;" @click="opendesignModal(row.item)">Info</button> -->
                        <b-col md="12" class="pull-right text-right">
                          <!-- <div class="pull-right"> -->
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
                          <template v-slot:button-content>
                            <button @click="opendesignModal(row.item)" style="border: none;" class="btn btn-link"><span class="cui-options icons font-1xl d-block" style="font-size: 15px;"></span></button>
                          </template>
                          <b-dropdown-item 
                          
                          target="_blank" >
                          <!-- <button v-b-modal.modal-lg type="button" class="btn btn-link"@click="opendesignModal(row.item)"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</button> -->
                          <!-- v-if="(user_type=='Brand_Designer' || user_type=='Buyer' || user_type=='Brand_Manager') && style_details.operational_status=='FH-Approved'" -->

                         <router-link :to="'/design_details/' + route_id"  ><b-button type="submit" variant="primary" ><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</b-button>
                          </router-link>
                          <!-- <router-link class="px-4 pull-right" :to="'/requested_quotation/' + route_id">
                        <b-button type="submit" variant="primary" class="px-4 pull-right" >Request Quote</b-button>
                      </router-link> -->


                        </b-dropdown-item>

                          </b-dropdown-item>
                        </b-dropdown>
                      <!-- </div> -->
                        </b-col>
                    </template>        
                  </b-table>
                </div>
                      <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>      
            <!-- Info modal -->         
                 <!-- </div> -->

                  </b-card-body>
               </b-col>
            </b-row>          
             <!-- code for table ends -->

             <!-- Code For Design Details Model -->
      <b-modal id="modal-lg" size="xl" title="Design Details" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" >

                 <!-- <b-row class="col-md-12">
          
        </b-row> -->
         <b-row class="col-md-12">
            
            <b-col cols="4">
               <div style="float: left;
                  border: 1px solid lightgray;">
                  <img v-bind:src="img_path" alt="No Image To Show" height="220" width="270" style="padding:5px;"/>

                  <!-- <b-form-group style="margin-top:25px;">
                        
                    <b-form-group>
                        <b-col md="9">
                        </b-col>
                      <b-col md="3" class="pull-right"><img v-bind:src="img_path" height="100px" width="100px" /></b-col></b-form-group>
                    
                  </b-form-group>     -->              
               </div>

              
                  
              

            </b-col>

            <b-col cols="8" >
              
               
              <div  class='col-md-12' >    

                <!-- <b-col md="6" class="pull-left"> -->
                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Brand Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.brand_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Segment Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.segment_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Collection Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.collection_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Sub Category Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.sub_cattitle}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.style_name}}
                   </b-col>
                  </b-form-group>


                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>PO Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.potype_title}}
                   </b-col>
                  </b-form-group>


                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Utility Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.utilitytype_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Color</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.color}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Operational Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.operational_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Design Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.design_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Description</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.style_description}}
                   </b-col>
                  </b-form-group>

                </div>  
               
            </b-col>
         </b-row>

            

                    
                 

              <!-- </div> -->
            
            <div slot="footer"  style="margin-top:20px;text-align:right" v-if="style_details.operational_status=='StyleNoCreated' || style_details.operational_status=='BH-approved'">
            
              <b-form-group
                  label="Comment"
                  :label-cols="3" >
                  <b-form-textarea rows="3" max-rows="6" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here...">
                  </b-form-textarea><br>
                  <b-input-group class="mb-3">
                      <label class="radio-inline"><input type="radio" name="optradio" value="approved" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                      <label class="radio-inline"><input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                      </b-input-group>
                                 
                </b-form-group>
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                  <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button>
                </div>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
             <!-- Code For Design Details Ends -->

 
      </div>
    </div>     
      
  </b-row>    





    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      items:[],
      result:[],
      value:[],
      sortDesc: true,
      sortDirection: 'desc',
      fields1: [
          { key: 'brand_title', label: 'Brand Title', sortable: true, sortDirection: 'desc' },
          { key: 'segment_title', label: 'Segment Title', sortable: true},
           { key: 'collection_title', label: 'Collection Title', sortable: true},
            { key: 'style_name', label: 'Style Name' ,tdClass: 'nameOfTheClass'},
            { key: 'operational_status', label: 'Status'},
            { key: 'comments', label: 'Section Feedback'},
          { key: 'action', label: 'Action' ,tdClass: 'nameOfTheClass'},
         
      
       ],
       
       showdesigndetails: false,
       currentPage: 1,
       perPage:  10,
       sortBy: null,
       sortDesc: true,
       sortDirection: 'desc',
       filter: null,
       totalRows: 0,
       selected_style_id: 0,
       style_details: [],
       img_path: '',
       status: '',
       comment: '',
       selected: '',
       style_name_arr: [],
       brand_title_arr: [],
       segment_title_arr: [],
       collection_title_arr: [],
       brand_title: '',
       showfeedbackmodel: false,
       feedback: '',
       route_id: 0,
       search_item: '',
       sub_cat_id_arr: [],
       selected: '',
       search_subcat: 0,
       search_utility: 0,
       search_po: 0,
   }

  },
  created: function() { 
  
  this.getfittechnicianstylelist(); 
   //this.getdesigndetail();
  },
 computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields1
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },

  
  methods: 
  {  
    closefeedback: function(){
      this.showfeedbackmodel = !this.showfeedbackmodel;
    },
            // Function For Action on status
    updatestylestatus: function(comment,value) {
      document.getElementById("overlay").style.display = "block";
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 
             
      const Obj={
        operational_status: status,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        style_id: this.selected_style_id,
        comments : comment
      } 
      axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data
        if (this.result.returnmsg === 'Successful') {
          // alert("Status Updated Successfully");
           this.$fire({
                 text:"Status Updated Successfully",
                 type: "success",
                 timer: 30000
                        })
          this.showdesigndetails = !this.showdesigndetails;
          this.getdesignheadstyledetails(); 
        }else {
         // alert("Please Check Status");
          this.$fire({
                 text:"Please Check Status",
                 type: "warning",
                 timer: 30000
                        })
          
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    commentcancel: function(){
      
      this.showdesigndetails = !this.showdesigndetails;
      // this.isBusy = !this.isBusy;
    },
    
        
           /****** Function to design details ********/
       getdesigndetail: function () {
         document.getElementById("overlay").style.display = "block";
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.selected_style_id 
                             
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.img_path = this.style_details.style_image;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },

    onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


      opendesignModal(value) {
        this.route_id=value.style_id;
        
 },

    getfittechnicianstylelist: function(value) 
    {
      //document.getElementById("overlay").style.display = "block";
      // this.isBusy = !this.isBusy;
      // var userdata = localStorage.getItem("userData");
      // var userInfo = JSON.parse(userdata);
      // this.login_user_id = userInfo[0].user_id;
      
      // const Obj = {
      //          user_id : this.login_user_id
      //         // user_id : 25
      //       }
     
      //   axios.post(`${CONSTANTS.API_URL}/getfittechnicianstylelist`,Obj)
      //   .then(response => {
      //     document.getElementById("overlay").style.display = "none";
      //     this.result = response.data

      //     if (this.result.returnmsg === 'Successful') {
            
      //       this.items  = this.result.returnvalue; 
            
      //       this.totalRows = this.result.returnvalue.length;
      //       this.isBusy = !this.isBusy;
            
      //     }else {
      //      this.items =[];
      //      this.totalRows=0;
      //        this.isBusy = !this.isBusy;
      //     }


      //   })
      //   .catch(e => {
      //     this.errors.push(e)
      //   })
      this.isBusy = !this.isBusy;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.login_user_id = userInfo[0].user_id;
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: 'ALL_Designs',
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
      
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforfit_tech`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            // this.operational_status = this.items.operational_status;
            
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      
    },

  }
}
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}


</style>


